import React from "react";
import { Menu } from "antd";
import { Link, useLocation } from "react-router-dom";
import style from "./style.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
const { SubMenu } = Menu;

function getSelectedKeys(pathname) {
  if (!pathname) return [];
  if (pathname.startsWith("/legislacao")) return ["legislacao"];
  if (pathname.startsWith("/questoes")) return ["/questoes"];
  if (pathname.startsWith("/concursos")) return ["/concursos"];
  if (pathname.startsWith("/cargos")) return ["/cargos"];
  if (pathname.startsWith("/bancas")) return ["/bancas"];
  if (pathname.startsWith("/orgaos")) return ["/orgaos"];
  if (pathname.startsWith("/disciplinas")) return ["/disciplinas"];
  if (pathname.startsWith("/grupo-de-estudos")) return ["/grupo-de-estudos"];
  return [];
}

export default function MenuBar() {
  const location = useLocation();
  const selectedKeys = getSelectedKeys(location?.pathname);

  return (
    <Menu
      className={style.menuBar}
      selectedKeys={selectedKeys}
      mode="horizontal"
    >
      <SubMenu key="legislacao" title="Legislação">
        <Menu.ItemGroup title="Federal">
          <Menu.Item key="legislacao:constituicao">
            <Link to="/legislacao/federal">Constituição Federal</Link>
          </Menu.Item>
          <Menu.Item key="legislacao:pesquisar">
            <Link to="/legislacao/federal/pesquisar">Pesquisar Constituição</Link>
          </Menu.Item>
        </Menu.ItemGroup>
      </SubMenu>

      <Menu.Item key="/questoes">
        <Link to={`/questoes`}>Questões</Link>
      </Menu.Item>

      <SubMenu key="/menuconcursos" title="Concursos">
        <Menu.Item key="/concursos">
          <Link to={`/concursos`}>Provas</Link>
        </Menu.Item>

        <Menu.Item key="/cargos">
          <Link to={`/cargos`}>Cargos</Link>
        </Menu.Item>

        <Menu.Item key="/bancas">
          <Link to={`/bancas`}>Bancas</Link>
        </Menu.Item>

        <Menu.Item key="/orgaos">
          <Link to={`/orgaos`}>Órgãos</Link>
        </Menu.Item>

        <Menu.Item key="/disciplinas">
          <Link to={`/disciplinas`}>Disciplinas</Link>
        </Menu.Item>
      </SubMenu>

      <Menu.Item key="/grupo-de-estudos">
        <Link to={`/grupo-de-estudos`}>Grupo de estudos</Link>
      </Menu.Item>

      <Menu.Item key="/instagram">
        <a
          className={style.socialIconLink}
          target="_BLANK"
          rel="noopener noreferrer"
          aria-label="Instagram"
          href="https://www.instagram.com/cade.direito"
        >
          <FontAwesomeIcon icon={faInstagram} className={style.socialIcon} />
        </a>
      </Menu.Item>
    </Menu>
  );
}
